module.exports = __webpack_public_path__ + "img/CHANGLIAN_BLUE.49422414.png";